/**
 * Return a positive, canonical, safely representable route unit ID unchanged.
 * @param {unknown} routeUnitId
 * @returns {string | null}
 */
export default function getCanonicalRouteUnitId(routeUnitId) {
  if (typeof routeUnitId !== 'string' || !/^[1-9]\d*$/.test(routeUnitId)) {
    return null;
  }

  return Number.isSafeInteger(Number(routeUnitId)) ? routeUnitId : null;
}
